const ProducsData = [
  {
    installments: "em até 3x no cartão",
    type: "Thermo abdômen",
    productBrand: "Bodyaction",
    description: "60 caps",
    priceWithoutDiscount: "100.00",
    quantity: "9",
    imageSrc: require("../../assets/ImgProducts/Thermogenic/thermo_abdomen_60caps.png"),
  },
];

export default ProducsData;
